import { BlockTitle } from "@blocks/Blocks";
import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";
import { ImagePresets } from "@routes/Article/components/ArticleThumbnail/utils/enums";
import { myBTTagsWithArticle } from "@routes/MyAccount/utils/types";
import { cn } from "@util/helpers";

export default function MyAccountMyBTCardList({
  tag,
  articles,
}: myBTTagsWithArticle): React.ReactElement {
  return (
    <div
      data-testid="my-account-my-bt-page-card-list-component"
      className="mb-8 border-t border-gray-175 pt-4 last:mb-0"
    >
      <BlockTitle
        text={tag.name}
        rootClassName="lg:text-lg mb-4"
        link={tag.urlPath}
      />

      {articles.map((cardsProps, index) => {
        const isLeadArticle = index === 0;

        const variant: CardVariations = {
          image: {
            width: "w-1/4",
            position: "right",
            filters: { w: ImagePresets.MEDIUM, h: 600, dpr: 1, f: "webp" },
          },
          content: {
            width: "w-3/4",
            extraClass: cn({
              "md:order-1 order-2 pl-4 md:pl-0 md:pr-4": isLeadArticle,
            }),
            blurb: {
              extraClass: cn("text-gray-850 font-public-sans text-xs pb-1", {
                "md:block": isLeadArticle,
              }),
            },
            updatedTimeExtraClass: cn("font-poppins text-7xs"),
            updatedTimeColor: cn("text-gray-850"),
            updatedTimeWrapperClass: cn("mt-1 lg:mt-auto"),
          },
          title: {
            size: "text-base",
            color: "text-gray-850",
            extraClass: cn("font-bold font-lct my-1"),
          },
        };

        return (
          <Card
            key={cardsProps.id}
            {...cardsProps}
            variations={variant}
            className="mb-4"
          />
        );
      })}
    </div>
  );
}
